import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloud } from "@fortawesome/free-solid-svg-icons";
import "./PointcloudButton.css";
import Tooltip from "@mui/material/Tooltip";

const PointcloudButton = ({ togglePointclouds }) => {
  return (
    <div className="pointcloud-button-container">
      <Tooltip
        title={
          <span style={{ fontSize: "14px" }}>
            <b>Toggle Point-Cloud Selection</b>
          </span>
        }
        placement="right"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "rgba( 83, 139, 34, 0.9)",
              fontFamily: "Maven pro",
              padding: "5px 10px",
              "& .MuiTooltip-arrow": {
                color: "rgba( 83, 139, 34, 0.9)",
              },
            },
          },
        }}
      >
        <button className="layer-layer-show" onClick={togglePointclouds}>
          <FontAwesomeIcon icon={faCloud} />
        </button>
      </Tooltip>
    </div>
  );
};

export default PointcloudButton;
